import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.185 2c1.159.05 2.039.99 1.989 2.081v3.942c0 .4-.33.72-.75.72s-.749-.32-.75-.72V4.041a.55.55 0 0 0-.53-.6H3.002c-.28.01-.52.27-.5.57v15.938c-.02.33.22.59.53.6h11.134c.27-.01.51-.27.5-.57v-4.012c0-.399.337-.717.744-.72l.152.015a.72.72 0 0 1 .593.705v3.982c.05 1.06-.82 1.99-1.949 2.051H2.991c-1.17-.06-2.039-.99-1.99-2.081V4.04c-.049-1.06.83-2 1.95-2.041zm4.118 6.184a.76.76 0 0 1 1.049 0l3.418 3.311c.07.07.12.15.16.23h.01a.67.67 0 0 1 0 .56c-.03.08-.09.16-.16.23l-3.418 3.312a.775.775 0 0 1-1.06 0 .71.71 0 0 1 0-1.02l2.14-2.081H7.897c-.42 0-.75-.321-.75-.721s.34-.72.75-.72h12.543l-2.138-2.08a.71.71 0 0 1 0-1.021" }, null, -1)
  ]))]))
}
export default { render: render }